import { CUSTOM_EVENTS } from '../constants/communication-custom-events';
import axios from 'axios';
import { SKEYS } from '../constants/storagekeys';

axios.defaults.headers.post['Content-Type'] = 'application/json';

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL
});

axiosInstance.interceptors.request.use(
  (request) => {
    // @ts-ignore
    const customToken = request?.customToken;
    let authToken = localStorage.getItem(SKEYS.AUTH);

    if (authToken && authToken.charAt(0) === '"') {
      authToken = authToken.slice(1, -1);
    }

    if (customToken) {
      request.headers['Authorization'] = `Bearer ${customToken}`;
    } else if (authToken) {
      request.headers['Authorization'] = `Bearer ${authToken}`;
    }

    const selectAccountId = localStorage.getItem(SKEYS.SELECT_ACCOUNT_ID);
    if (selectAccountId) {
      request.headers['SelectAccountId'] = selectAccountId;
    }

    return request;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const apiVersion = response.headers['brandbow-api-version'];

    if (apiVersion) {
      // TODO Pass via redux
      window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.CHANGE_API_VERSION, { detail: { apiVersion } }));
    }

    return response;
  },
  (error) => {
    const status = error.response.status;

    if (status === 401) {
      // TODO Pass via redux
      window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.LOGOUT_ACTION));
    } else {
      return Promise.reject(error);
    }
  }
);

// axios.interceptors.response.eject(responseInterceptor);

export const CancelToken = axios.CancelToken;

export default axiosInstance;
